export default {
  moreDetails: {
    id: 'buyback_my_sales_more_details',
    defaultMessage: 'See more details',
  },
}
